import React, { useEffect, useState } from "react";
import cn from "classnames";
import { useLocation } from "react-router-dom";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import arrow from "@src/assets/svg/arrow.svg";
import { GatewaysListRow } from "../gateways-list-row/gateways-list-row";
import styles from "./gateways-list-body.module.scss";
import { GatewaysListPropTypes } from "@src/components/organisms/gateways-list/gateways-list";
import { GatewayWithSourceViewStateTypes } from "@common/types/gateways-list-types";

const cssClassName = "gateways-list-body";

export const GatewaysListBody = ({
  data = [],
  description,
}: Partial<GatewaysListPropTypes>) => {
  const location = useLocation();
  const [isGridVisible, setIsGridVisible] = useState(true);
  const targetGatewayUuid =
    new URLSearchParams(location.search).get("gateway_uuid")?.trim() || "";

  useEffect(() => {
    if (targetGatewayUuid && !isGridVisible) {
      setIsGridVisible(true);
    }
  }, [targetGatewayUuid, isGridVisible]);

  const toggleGridVisibility = () => {
    setIsGridVisible(!isGridVisible);
  };

  // Always return an array of <tr> elements
  const rows = [
    <tr key="description">
      <td className={styles[`${cssClassName}__description-container`]}>
        <span className={styles[`${cssClassName}__description-text`]}>
          {description}
        </span>
        <span
          className={cn(
            styles[`${cssClassName}__description-text`],
            styles[`${cssClassName}__description-text--gray`],
          )}
        >
          {data.length}
        </span>
        <IconButton
          icon={arrow}
          fun={toggleGridVisibility}
          rotate={isGridVisible}
        />
      </td>
    </tr>,
  ];

  if (isGridVisible && data) {
    rows.push(
      ...data.map((gatewayData: GatewayWithSourceViewStateTypes, i: number) => (
        <GatewaysListRow
          key={gatewayData.gateway_uuid || i}
          gatewayData={gatewayData}
        />
      )),
    );
  }

  return rows;
};
